export default "27.2.027\n"